package org.vreo.devicehub.features.userAuthentication.data.dto

import kotlinx.serialization.Serializable

/**
 * User registration response dto
 *
 * @property validationCodeValidUntil unix time stamp until when validation code is valid
 */
@Serializable
data class UserRegistrationResponseDto(
    val validationCodeValidUntil: Long
)